import config from '@/config';
import { HTTP } from './base';

const { AUTH_URL } = config;
const PASSWORD_GRANT_TYPE = 'password';
const REFRESH_GRANT_TYPE = 'refresh_token';

export default {
  create({ username, password }) {
    return HTTP.post(`${AUTH_URL}/auth/token`, {
      username,
      password,
      grant_type: PASSWORD_GRANT_TYPE
    });
  },
  revoke({ token }) {
    return HTTP.post(`${AUTH_URL}/auth/revoke`, { token });
  },
  refresh(refreshToken) {
    return HTTP.post(`${AUTH_URL}/auth/token`, {
      refresh_token: refreshToken,
      grant_type: REFRESH_GRANT_TYPE
    });
  }
};
